// Đánh dấu "đang bận, đừng tải lại trang" cho những việc bị cắt ngang là hỏng: đang ghép ảnh,
// đang đẩy tệp lên S3, đang lưu phiếu… AppVersionSnackbar hỏi ở đây trước khi tự tải lại trang
// để lên phiên bản mới.

const viecDangLam = new Set();

/** Bật/tắt một việc đang làm (khoá tuỳ ý, mỗi việc một khoá). */
export function datDangBan(khoa, ban) {
    if (ban) viecDangLam.add(khoa);
    else viecDangLam.delete(khoa);
}

export const coViecDangLam = () => viecDangLam.size > 0;
